<template>
  <div class="Allupload-page">
    <!-- v-if="isUpload" -->
    <div class="showCricle" @click="showlist" v-if="arr.length > 0">
      {{ arr[0].percent }}%
    </div>
    <!-- 显示列表 -->
    <div class="upbox" :class="flagupload ? 'active' : ''">
      <div class="up-left">
        <span class="up-l-title">传输列表</span>
        <li
          class="up-list"
          :class="{ active: 0 == index }"
          v-for="(item, index) in arr"
          :key="index"
        >
          <div style="display:inline-block;" @click="nowclick = index">
            任务{{ index + 1 }}
            <span v-if="index == 0">(进行中)</span>
            <span v-else>(等待)</span>
          </div>
          <i v-if="index != 0" class="el-icon-close" @click="clear(index)"></i>
        </li>
      </div>
      <div class="up-right">
        <div
          v-show="nowclick == index"
          v-for="(value, index) in arr"
          :key="index"
        >
          <div class="head">
            <div>
              <span v-if="value.isUpload">正在上传</span>
              <span v-else>等待上传</span>
              --任务{{ index + 1 }} ({{ value.allnum }}/{{ value.uploadnumZ }})
            </div>
            <div>
              <span class="close" @click="allclear">全部取消</span>
            </div>
          </div>
          <div class="progress">
            <li v-for="(item, iex) in value.uploadinfo" :key="iex">
              <div class="mflex" v-if="item != 1">
                <img
                  src="https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/upload/file.png"
                  style=""
                />
                <div style="width:70%;">
                  <div class="uploadtitleS">
                    <span class="uploadtitle one-text" :title="item.title">{{
                      item.title
                    }}</span>
                  </div>
                  <div style="width:100%;">
                    <el-progress
                      class="uploadbtn"
                      :show-text="false"
                      :stroke-width="6"
                      :percentage="item.progress"
                      status="success"
                      v-if="item.progress != 0 && item != 1"
                    >
                    </el-progress>
                    <span class="uploadbtn" v-else></span>
                  </div>
                </div>
                <button
                  class="closebtn"
                  v-if="item.progress == 0"
                  @click="noupload(index, iex)"
                >
                  取消
                </button>
              </div>
            </li>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "../../common/bus.js";
import { getPostfix } from "@/common/tolls.js";
import { TaiyuanForeignLanSchoolId } from "@/common/constant";
import { mapState } from "vuex";
export default {
  name: "comUpload",
  computed: {
    ...mapState({
      userinfo: state => state.user.userinfo, //个人信息
      fileType: state => state.department.fileType,
      clickchap: state => state.xiaoben.clickchap //资源获取条件
    })
  },
  data() {
    return {
      flagupload: false,
      arr: [],
      nowclick: 0,
      uploading: false
    };
  },

  watch: {
    arr: {
      //深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        console.log("传输数据", JSON.stringify(val), oldVal);
        if (this.arr.length == 0) {
          this.flagupload = false;
          return false;
        }
        if (this.arr[0].isUpload == false) {
          this.open();
        }
      },
      deep: true //true 深度监听
    }
  },
  methods: {
    //
    showlist() {
      let that = this;
      that.flagupload = !that.flagupload;
    },
    //开始执行
    open() {
      let that = this;
      this.arr[0].isUpload = true;
      if (this.arr[0].type == "folder") {
        //文件夹
        this.foldercreat(
          this.arr[0].folderarr,
          this.arr[0].startnum,
          this.arr[0].uploadnumZ
        );
      } else if (this.arr[0].type == "file") {
        //文件
        this.uploadaction(this.arr[0].startnum, this.arr[0].uploadnumZ);
      }
    },
    //清除当前全部任务
    allclear() {
      this.arr.splice(this.nowclick, 1);
      this.flagupload = false;
      this.uploading = true;
      this.nowclick = 0;
    },
    // 清除某个进程任务
    clear(index) {
      this.arr.splice(index, 1);
    },
    // 清除某个任务
    noupload(index, ind) {
      this.arr[index].sizetotal =
        this.arr[index].sizetotal - this.arr[index].uploadfiles[ind].size;
      this.arr[index].percent = parseInt(
        (this.arr[index].uptsize / this.arr[index].sizetotal).toFixed(2) * 100
      );
      this.arr[index].uploadfiles.splice(ind, 1);
      this.arr[index].uploadinfo.splice(ind, 1);
      this.arr[index].uploadnumZ = this.arr[index].uploadnumZ - 1;
    },
    // 名字随机
    getRandomName() {
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var rand = "",
        len = 2;
      for (let i = 0; i < len; i++) {
        rand += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return `${Date.now()}${rand}`;
    },
    // 文件夹------------------------------
    // 批量创建文件夹
    async foldercreat(arr, startnum, uploadnum) {
      let that = this;
      let nowData = this.arr[0];
      let params;
      for (let i = 0; i < arr.length; i++) {
        if (that.uploading) {
          that.uploading = false;
          return false;
        }
        if (nowData.source == "personalSpace") {
          params = {
            userid: window.localStorage.getItem("userid"), //int	用户id	是	否
            foldername: arr[i].title //	string	文件夹名字	是
          };
        } else if (nowData.source == "department") {
          params = {
            userid: window.localStorage.getItem("userid"), //int	用户id	是	否
            foldername: arr[i].title, //	string	文件夹名字	是
            deptid: nowData.deptid, //	int	部门id	是	否
            deptname: nowData.deptname //
          };
          // if()
        } else if (nowData.source == "shareFile") {
          params = {
            userid:
              that.userinfo.userid || window.localStorage.getItem("userid"), //int	用户id	是	否
            foldername: arr[i].title //	string	文件夹名字	是
          };
        }
        if (arr[i].pids != 0) {
          for (let j = 0; j < arr.length; j++) {
            if (
              arr[j].pids + 1 == arr[i].pids &&
              arr[j].path + "/" + arr[i].title == arr[i].path
            ) {
              params.pid = arr[j].id;
            }
          }
        } else {
          params.pid = arr[i].pid;
        }
        console.log(
          "创建文件夹",
          that.userinfo.schoolid,
          TaiyuanForeignLanSchoolId
        );
        if (that.userinfo.schoolid === TaiyuanForeignLanSchoolId) {
          params.file_type = this.fileType;
        }
        console.log(params);
        if (nowData.source == "personalSpace") {
          //私人文件夹
          let { code, data } = await that.$http({
            url: "index/user.UserFile/newfolder",
            method: "post",
            data: params
          });
          arr[i].id = data;
        } else if (nowData.source == "department") {
          //部门资源
          let { code, data } = await that.$http({
            url: "index/department.Dept/newfolder",
            method: "post",
            data: params
          });
          arr[i].id = data;
        } else if (nowData.source == "shareFile") {
          //共享文件
          console.log("新建共享文件夹1");
          let { code, data } = await that.$http({
            url: "index/department.Dept/newsharefolder",
            method: "post",
            data: params
          });
          arr[i].id = data;
        }
      }
      let success = 0;
      for (let i = 0; i < arr.length; i++) {
        arr[i].id != "" ? (success += 1) : "";
      }
      if (success == arr.length) {
        this.uploadFloder(arr, startnum, uploadnum);
      }
    },

    // 文件夹文件上传
    async uploadFloder(folder, startnum, endnum) {
      let that = this;
      let nowData = that.arr[0]; //当前上传对象
      console.log("上传对象：", nowData);
      let uploadarr = that.arr[0].uploadinfo; //上传状态列表
      let filearr = that.arr[0].uploadfiles; //上传文件列表
      for (var i = 0; i < uploadarr.length; i++) {
        for (let j = 0; j < folder.length; j++) {
          if (that.uploading) {
            that.uploading = false;
            return false;
          }
          if (folder[j].path == uploadarr[i].filename) {
            var file = filearr[i];
            let request_url,
              params = {};
            if (nowData.source == "personalSpace") {
              //个人空间
              request_url = `/index/user.UserFile/getossid`;
              params = {
                userid:
                  that.userinfo.userid || window.localStorage.getItem("userid")
              };
            } else if (nowData.source == "department") {
              //部门资源
              request_url = `/index/department.Dept/getossid`;
              params = {
                deptid: nowData.deptid
              };
            } else if (nowData.source == "shareFile") {
              request_url = `/index/department.Dept/getossid`;
              params = {
                deptid: 0
              };
            }
            console.log("获取ossid----");
            let { data } = await this.$localhttp({
              url: `${request_url}`,
              method: "get",
              params: params
            });
            let { accessid, host, policy, signature, dir } = data;
            var form = new FormData(),
              randomName = that.getRandomName(file),
              filename = `${dir}${randomName}${getPostfix(file.name)}`;
            form.append("key", `${filename}`);
            form.append("policy", policy);
            form.append("OSSAccessKeyId", accessid);
            form.append("success_action_status", "200");
            form.append("signature", signature);
            form.append("file", file);
            uploadarr[i]["title"] = file.name;
            console.log("阿里云--文件上传参数", form);
            let { status } = await this.$http({
              url: `${host}`,
              data: form,
              method: "POST",
              onUploadProgress({ total, loaded }) {
                var progress = parseInt((loaded * 100) / total);
                uploadarr[i]["progress"] = progress;
                uploadarr[i]["start"] = "上传中...";
                if (progress >= 100) {
                  uploadarr[i]["start"] = "已完成";
                }
                let uping = nowData.uptsize + loaded;
                if (uping <= nowData.sizetotal) {
                  nowData.percent = parseInt(
                    (uping / nowData.sizetotal).toFixed(2) * 100
                  );
                }
              }
            });
            if (status == 200) {
              nowData.uptsize += uploadarr[i]["size"];
              nowData.allnum++;
              uploadarr[i]["status"] = 1;
              if (nowData.source == "personalSpace") {
                //个人空间
                this.folderToEnd(filename, file, folder[j]);
              } else if (nowData.source == "department") {
                //部门资源
                this.folderdepartment(filename, file, folder[j]);
              } else if (nowData.source == "shareFile") {
                //共享文件夹
                this.sharefolderdepartment(filename, file, folder[j]);
              }
            } else {
              uploadarr[i]["status"] = 2;
              this.$message.error("文件上传失败");
            }

            if (nowData.allnum == nowData.uploadnumZ) {
              this.$message.success("上传成功！");
              nowData.percent = 100;
              setTimeout(function() {
                if (nowData.source == "personalSpace") {
                  //个人空间
                  that.$store.dispatch("personal/getuserfilelist", {
                    schoolid: that.userinfo.schoolid,
                    page: 1,
                    pid: nowData.pid
                  });
                } else if (nowData.source == "department") {
                  //部门资源
                  that.$store.dispatch("department/getdepartmentziyuan", {
                    schoolid: that.userinfo.schoolid,
                    page: 1,
                    pid: nowData.pid,
                    deptid: nowData.deptid,
                    fileType: that.fileType
                  });
                } else if (nowData.source == "shareFile") {
                  //共享文件夹
                  console.log("共享文件夹", {
                    schoolid: that.userinfo.schoolid,
                    page: 1,
                    pid: nowData.pid,
                    fileType: this.fileType
                  });
                  that.$store.dispatch("department/getshareziyuan", {
                    schoolid: that.userinfo.schoolid,
                    page: 1,
                    pid: nowData.pid,
                    fileType: this.fileType
                  });
                }

                that.arr.splice(0, 1);
              }, 200);
              break;
            }
          }
          // if(folder[j].title == uploadarr[i].filename){

          // }
        }
      }
    },
    //个人空间文件夹上传
    folderToEnd(resname, file, parentinfo) {
      let that = this;
      var data = {
        title: file.name,
        size: file.size,
        userid: this.userinfo.userid, //	int	用户id	是	否
        pid: parentinfo.id, //	int	父级id	是	否
        resname: resname //	string	阿里云文件地址	是	否
      };
      var request_url = `/index/user.UserFile/uploadUserFile`;
      console.log(request_url, data);
      this.$http({
        url: `${request_url}`,
        method: "post",
        data: data
      })
        .then(res => {})
        .catch(err => {});
    },
    //部门文件上传
    folderdepartment(resname, file, parentinfo) {
      let that = this;
      let nowData = that.arr[0];
      var data = {
        title: file.name,
        size: file.size,
        userid: this.userinfo.userid, //	int	用户id	是	否
        deptid: nowData.deptid, //	int	部门id	是	否
        deptname: nowData.deptname, //	string	部门名称	是	否
        pid: parentinfo.id, //	int	父级id	是	否
        resname: resname //	string	阿里云文件地址	是	否
      };
      console.log("部门文件上传", this.arr[0]);
      if (this.arr[0].education && this.arr[0].education.file_type) {
        data.file_type = this.arr[0].education.file_type;
      }
      var request_url = `/index/department.Dept/uploadFile`;
      console.log(request_url, data, 'pid:', data.pid);
      this.$http({
        url: `${request_url}`,
        method: "post",
        data: data
      })
        .then(res => {})
        .catch(err => {});
    },
    //共享文件上传
    sharefolderdepartment(resname, file, parentinfo) {
      let that = this;
      let nowData = that.arr[0];
      var data = {
        title: file.name,
        size: file.size,
        userid: this.userinfo.userid, //	int	用户id	是	否
        pid: parentinfo.id, //	int	父级id	是	否
        resname: resname //	string	阿里云文件地址	是	否
      };
      console.log("上传---");
      var request_url = `/index/department.Dept/uploadShareFile`;
      console.log(request_url, data);
      this.$http({
        url: `${request_url}`,
        method: "post",
        data: data
      })
        .then(res => {})
        .catch(err => {});
    },
    // -------------------文件夹结束
    //-----------------------------------------------------上传文件-----------------------------------
    //上传文件函数
    async uploadaction(startnum, endnum) {
      let that = this;
      var newfilename = "";
      let uploadarr = that.arr[0].uploadinfo;
      let uploadfiles = that.arr[0].uploadfiles;
      let nowData = that.arr[0]; //当前上传对象
      for (var i = startnum; i < endnum; i++) {
        if (that.uploading) {
          that.uploading = false;
          return false;
        }
        let file = uploadfiles[i];
        let request_url, params;
        if (nowData.source == "personalSpace") {
          //个人空间
          request_url = `/index/user.UserFile/getossid`;
          params = {
            userid: this.userinfo.userid
          };
        } else if (nowData.source == "department") {
          //部门资源
          request_url = `/index/department.Dept/getossid`;
          params = {
            deptid: nowData.deptid
          };
        } else if (nowData.source == "shareFile") {
          //共享文件
          request_url = `/index/department.Dept/getossid`;
          params = {
            deptid: 0
          };
        } else if (nowData.source == "resource") {
          //教学资源上传
          request_url = `/index/resource.Schres/getossid`;
          params = {
            schoolid: nowData.education.schoolid,
            restype: nowData.education.restype
          };
        } else if (nowData.source == "giveLessons") {
          //教学资源上传
          request_url = `/index/resource.Schres/getossid`;
          params = {
            schoolid: nowData.education.schoolid,
            restype: nowData.education.restype
          };
        }
        console.log("获取oss-id：", params);
        let { data } = await this.$localhttp({
          url: `${request_url}`,
          method: "get",
          params
        });
        let { accessid, host, policy, signature, dir } = data;
        var form = new FormData(),
          randomName = this.getRandomName(file),
          filename = `${dir}${randomName}${getPostfix(file.name)}`;
        form.append("key", `${filename}`);
        form.append("policy", policy);
        form.append("OSSAccessKeyId", accessid);
        form.append("success_action_status", "200");
        form.append("signature", signature);
        form.append("file", file);
        console.log("阿里云-上传文件参数：", form);
        let { status } = await this.$http({
          url: `${host}`,
          data: form,
          method: "POST",
          onUploadProgress({ total, loaded }) {
            var progress = parseInt((loaded * 100) / total);
            uploadarr[i]["progress"] = progress;
            uploadarr[i]["start"] = "上传中...";
            if (progress >= 100) {
              uploadarr[i]["start"] = "已完成";
            }
            let uping = nowData.uptsize + loaded;
            if (uping <= nowData.sizetotal) {
              nowData.percent = parseInt(
                (uping / nowData.sizetotal).toFixed(2) * 100
              );
            }
          }
        });
        if (status == 200) {
          nowData.uptsize += uploadarr[i]["size"];
          nowData.allnum++;
          uploadarr[i]["status"] = 1;
          if (nowData.source == "personalSpace") {
            //个人空间
            this.reportToEnd(filename, file);
          } else if (nowData.source == "department") {
            //部门资源
            this.dempartload(filename, file);
          } else if (nowData.source == "shareFile") {
            //共享文件
            this.sharefile(filename, file);
          } else if (nowData.source == "resource") {
            //共享文件
            this.resourcefile(filename, file);
          } else if (nowData.source == "giveLessons") {
            //授课资源
            this.giveLessonsfile(filename, file);
          }
        } else {
          uploadarr[i]["status"] = 2;
          this.$message.error("文件上传失败");
        }
        if (nowData.allnum == nowData.uploadnumZ) {
          this.$message.success("上传成功！");
          nowData.percent = 100;
          setTimeout(function() {
            let types = nowData.source;
            switch (types) {
              case "personalSpace":
                that.$store.dispatch("personal/getuserfilelist", {
                  schoolid: that.userinfo.schoolid,
                  page: 1,
                  pid: nowData.pid
                });
                break;
              case "department":
                that.$store.dispatch("department/getdepartmentziyuan", {
                  schoolid: that.userinfo.schoolid,
                  page: 1,
                  pid: nowData.pid,
                  deptid: nowData.deptid,
                  fileType: that.fileType
                });
                break;
              case "shareFile":
                console.log("shareFile", that.fileType);
                that.$store.dispatch("department/getshareziyuan", {
                  schoolid: that.userinfo.schoolid,
                  page: 1,
                  pid: nowData.pid,
                  fileType: that.fileType
                });
                break;
              case "resource":
                that.$store.dispatch("xiaoben/getziyuanlist", that.clickchap);
                break;
            }
            that.arr.splice(0, 1);
          }, 200);
          break;
        }
      }
    }, //文件入库操作
    // 私人文件夹上传接口
    reportToEnd(resname, file) {
      let that = this;
      var data = {
        title: file.name,
        size: file.size,
        userid: this.userinfo.userid, //	int	用户id	是	否
        pid: that.arr[0].pid, //	int	父级id	是	否
        resname: resname //	string	阿里云文件地址	是	否
      };
      var request_url = `/index/user.UserFile/uploadUserFile`; //私人文件夹添加
      console.log("个人空间数据上传：", data);
      this.$http({
        url: `${request_url}`,
        method: "post",
        data: data
      })
        .then(res => {
          that.$store.dispatch("personal/getuserfilelist", {
            schoolid: that.userinfo.schoolid,
            page: 1
          });
        })
        .catch(err => {});
    },
    // 部门资源上传
    dempartload(resname, file) {
      let that = this;
      console.log('数据： ', JSON.stringify(that.arr[0]))
      var data = {
        title: file.name,
        size: file.size,
        userid: this.userinfo.userid, //	int	用户id	是	否
        deptid: that.arr[0].deptid, //	int	部门id	是	否
        deptname: that.arr[0].deptname, //	string	部门名称	是	否
        pid: that.arr[0].pid, //	int	父级id	是	否
        resname: resname //	string	阿里云文件地址	是	否
      };
      if (this.arr[0].education && this.arr[0].education.file_type) {
        data.file_type = this.arr[0].education.file_type;
      }
      var request_url = `/index/department.Dept/uploadFile`;
      console.log("部门资源数据上传：", request_url,'pid: ', data.pid);
      this.$http2({
        url: `${request_url}`,
        method: "post",
        data: data
      })
        .then(res => {})
        .catch(err => {});
    },
    //共享文件
    sharefile(resname, file) {
      let that = this;
      var data = {
        title: file.name,
        size: file.size,
        userid: this.userinfo.userid, //	int	用户id	是	否
        pid: that.arr[0].pid, //	int	父级id	是	否
        resname: resname //	string	阿里云文件地址	是	否
      };
      if (this.arr[0].education && this.arr[0].education.file_type) {
        data.file_type = this.arr[0].education.file_type;
      }
      var request_url = `/index/department.Dept/uploadShareFile`;
      console.log("共享文件数据上传：", request_url, data);
      this.$http({
        url: `${request_url}`,
        method: "post",
        data: data
      })
        .then(res => {})
        .catch(err => {});
    },
    //资源上传
    resourcefile(resname, file) {
      let that = this;
      var data = {
        title: file.name,
        size: file.size,
        userid: that.arr[0].education.userid, //	int	用户id	是	否
        resname: resname, //	string	阿里云文件地址	是	否
        restype: that.arr[0].education.restype,
        xueduan_id: that.arr[0].education.xueduan_id,
        subject_id: that.arr[0].education.subject_id,
        version_id: that.arr[0].education.version_id,
        cebie_id: that.arr[0].education.cebie_id,
        xueduan_name: that.arr[0].education.xueduan_name,
        subject_name: that.arr[0].education.subject_name,
        version_name: that.arr[0].education.version_name,
        cebie_name: that.arr[0].education.cebie_name,
        info: that.arr[0].education.info,
        chapterid: that.arr[0].education.chapterid,
        jie: that.arr[0].education.jie
      };
      if (that.arr[0].pjie != undefined) {
        data.pjie = that.arr[0].pjie;
      }
      var request_url = `/index/resource.Schres/upload`;
      console.log(request_url, data);
      this.$http({
        url: `${request_url}`,
        method: "post",
        data: data
      })
        .then(res => {
          // that.$store.dispatch('xiaoben/getziyuanlist', this.clickchap);
        })
        .catch(err => {});
    },
    // 授课资源
    giveLessonsfile(resname, file) {
      let that = this;
      // this.changfilearr,this.tree_infos,this.chapterides,this.skchapteridname
      var data = {
        title: file.name,
        size: file.size,
        userid: that.arr[0].education.userid, //	int	用户id	是	否
        resname: resname, //	string	阿里云文件地址	是	否
        restype: that.arr[0].education.restype,
        xueduan_id: that.arr[0].education.xueduan_id,
        subject_id: that.arr[0].education.subject_id,
        version_id: that.arr[0].education.version_id,
        cebie_id: that.arr[0].education.cebie_id,
        xueduan_name: that.arr[0].education.xueduan_name,
        subject_name: that.arr[0].education.subject_name,
        version_name: that.arr[0].education.version_name,
        cebie_name: that.arr[0].education.cebie_name,
        jie: that.arr[0].education.jie,
        chapterid: that.arr[0].education.chapterid,
        grade_id: that.arr[0].education.grade_id,
        grade_name: that.arr[0].education.grade_name,
        start_time: that.arr[0].education.start_time, //课开始时间
        end_time: that.arr[0].education.end_time, //课结束时间
        wstart_time: that.arr[0].education.wstart_time, //周开始时间
        wend_time: that.arr[0].education.wend_time, //周结束时间
        classorder: that.arr[0].education.classorder,
        dayname: that.arr[0].education.dayname,
        day: that.arr[0].education.day
      };
      if (that.arr[0].newpjie != undefined) {
        data.newpjie = that.arr[0].newpjie;
      }
      var request_url = `/index/resource.Beike/shoukeUpload`;
      console.log("授课资源-数据上传");
      this.$http({
        url: `${request_url}`,
        method: "post",
        data: data
      })
        .then(res => {})
        .catch(err => {});
    }
    // ---------------文件结束
  },
  created() {
    let that = this;
    Bus.$on("getTarget", target => {
      that.arr.push(target);
    });
  }
};
</script>

<style scoped>
.Allupload-page {
  position: fixed;
  right: 10px;
  top: 79px;
  z-index: 20;
}
.showCricle {
  display: block;
  width: 63px;
  height: 63px;
  background: url("https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/upload/qiu.png")
    no-repeat center center;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
  line-height: 63px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #4d8bff;
  user-select: none;
}
.showCricle:hover {
  box-shadow: 0px 0px 10px 0px rgba(77, 139, 255, 1);
}
/*上传列表*/
.upbox {
  position: absolute;
  width: 520px;
  height: 300px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(119, 119, 119, 0.28);
  border-radius: 10px;
  display: flex;
  top: 64px;
  right: -530px;
  transition: right 1s ease-in-out;
}
.upbox.active {
  right: 0px;
  transition: right 1s ease-in-out;
}
.up-left {
  width: 130px;
  height: 100%;
  padding: 15px 12px;
  box-sizing: border-box;
  border-right: 2px solid #f0f0f0;
}
.up-list {
  width: 104px;
  height: 29px;
  line-height: 29px;
  margin-top: 5px;
  cursor: pointer;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  padding-left: 9px;
}
.up-list.active {
  background: #e8f0fe;
  border-radius: 6px;
  color: #4f87ec;
}
.up-list i {
  color: #447de1;
}
.up-l-title {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  margin-bottom: 10px;
  display: block;
}
.up-right {
  width: 400px;
  height: 100%;
}
.head {
  height: 38px;
  line-height: 38px;
  display: flex;
  justify-content: space-between;
  padding: 0 23px;
  border-bottom: 1px solid #f0f0f0;
}
.head .close {
  cursor: pointer;
  color: #447de1;
}
.closebtn {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #447de1;
  margin-left: 24px;
  cursor: pointer;
}

/*进度条*/
.progress {
  /* 	position: fixed;
		right: 10px;
		bottom: 10px; */
  z-index: 100;
  overflow-y: scroll;
  /* height: 180px; */
  height: 258px;
  /* border: 1px solid #ccc; */
  /* padding: 10px; */
  border-radius: 8px;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
}

.progress li {
  margin: 10px 0 10px 0;
  position: relative;
}
.progress img {
  width: 24px;
  margin-right: 14px;
}

.uploadtitleS {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: space-between;
  padding-right: 10px;
  box-sizing: border-box;
}

.uploadtitle {
  display: inline-block;
  width: 230px;
  height: 30px;
  text-align: left;
  line-height: 30px;
  overflow: hidden;
  padding-left: 2px;
}

.uploadstatus {
  display: inline-block;
  height: 6px;
  line-height: 6px;
}

.uploadbtn {
  width: 100%;
  height: 6px;
  line-height: 6px;
  display: block;
  text-align: center;
  background: #e0e0e0;
  color: #fff;
  font-size: 14px;
  border-radius: 100px;
}

.uploadbtn:hover {
  background: #a0cfff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/AllUpload.vue